'use client';

import { useEffectOnce } from 'react-use';
import scheduleIdleAfterLCP from '@/joystagram-components/commons/scheduleIdleAfterLCP';
import ensurePostHogClientInitialized from './ensurePostHogClientInitialized';
import getClientShouldUseCookielessMode from './getClientShouldUseCookielessMode';
const PostHogDeferredInit = () => {
  useEffectOnce(_temp3);
  return null;
};
export default PostHogDeferredInit;
function _temp() {}
function _temp2() {
  ensurePostHogClientInitialized({
    shouldUseCookielessMode: getClientShouldUseCookielessMode()
  }).catch(_temp);
}
function _temp3() {
  const cancel = scheduleIdleAfterLCP(_temp2);
  return cancel;
}